<template lang="pug">
  multiselect(
    :value="value"
    :options="stateList"
    placeholder="Type to search"
    label="Desc_en"
    track-by="Desc_en"
    name="code"
    @input="onInput"
    :disabled="disabled"
    :loading="state_loading"
    :internalSearch="true"
    @search-change="loadState"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.Desc_en }}
</template>

<script>
import jsonData from './e-invoice/StateCodes.json';
import _ from 'lodash';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            stateList: [],
            state_loading: false,
        };
    },
    mounted() {
        this.loadState();
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
        loadState: _.debounce(function(query) {
            this.state_loading = true;

            if (query) {
                this.stateList = jsonData.filter(item =>
                    item.Desc_en.toLowerCase().includes(query.toLowerCase()),
                );
            } else {
                this.stateList = jsonData;
            }

            this.state_loading = false;
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/eStateSelector.vue